import { confirmation, notify } from '@/components';
import {
  useHideArticleMutation,
  usePublishArticleMutation,
} from '@/redux/articles';
import { useTranslation } from 'react-i18next';

const usePublish = () => {
  const [publish] = usePublishArticleMutation();
  const { t } = useTranslation();

  return async (id: string) => {
    confirmation.show({
      confirm: t('articles.action.publish'),
      body: t('articles.confirm.publish'),
      onConfirm: () => {
        publish({ id })
          .unwrap()
          .then(() => {
            notify.success.t('articles.details.saved');
          });
      },
    });
  };
};

const useHide = () => {
  const [hide] = useHideArticleMutation();
  const { t } = useTranslation();

  return async (id: string) => {
    confirmation.show({
      confirm: t('articles.action.hide'),
      body: t('articles.confirm.hide'),
      onConfirm: () => {
        hide({ id })
          .unwrap()
          .then(() => {
            notify.success.t('articles.details.saved');
          });
      },
    });
  };
};

export function useUpdateArticleStatusAction() {
  const publishAction = usePublish();
  const hideAction = useHide();

  return {
    publishAction,
    hideAction,
  };
}
